import classes from './BackgroundCircle.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  size?: 'normal'
  color?: 'highlight-purple'
  children: ReactNode
}

const BackgroundCircle = ({
  size = 'normal',
  color = 'highlight-purple',
  children
}: Props) => {
  const styleClasses = [
    classes.BackgroundCircle,
    classes[size],
    classes[color]
  ].filter(style => style).join(' ')

  return (
    <div className={styleClasses}>
      {children}
    </div>
  )
}

export default BackgroundCircle
